import { useContext } from 'react';

import { FormFillPageContext } from '@/components/form-fill-page-provider';

function useFormFillPage() {
	const context = useContext(FormFillPageContext);

	return context;
}

export default useFormFillPage;
